const isApiAccommodationListPromoOutOfRange = (value) => Object.hasOwn(value, 'promo_available');
const isApiAccommodationListInvalidAllotmentBlockCode = (value) => Object.hasOwn(value, 'allotment_block_code_error');
export const isApiAccommodationListError = (value) => isApiAccommodationListPromoOutOfRange(value) ||
    isApiAccommodationListInvalidAllotmentBlockCode(value);
